import uuid from 'uuid'
import cookies from '../../../../website/apps/web/src/utils/cookies'
// eslint-disable-next-line import/no-cycle
import CONSTANTS from '../constants'


const retrieveDeviceId = () => {
  const newDeviceId = uuid.v1()
  try {
    return cookies.get('device_id') || localStorage.getItem('device_id') || newDeviceId
  } catch (error) {
    return newDeviceId
  }
}

/**
 * Get device ID
 * @returns {string}
 */
export const getDeviceId = () => {
  const deviceId = retrieveDeviceId()
  try {
    cookies.set('device_id', deviceId)
    localStorage.setItem('device_id', deviceId)
  } catch (e) { /* ignore errors */ }
  return deviceId
}

/**
 * Get separate subscription flag
 * @param {Location} frameLocation
 * @param {Location} parentLocation
 * @param {string} referrer
 * @param {array} checkoutHosts
 * @param {object} confVariables
 * @returns {boolean}
 */
export const isSeparateSubscription = (frameLocation, parentLocation, referrer, checkoutHosts, confVariables) => {
  const parentUrl = (frameLocation !== parentLocation)
    ? referrer
    : frameLocation.href
  let isCheckoutSite = false
  checkoutHosts.forEach(host => {
    if (parentUrl.indexOf(host) > -1) {
      isCheckoutSite = true
    }
  })
  // for all checkout.timeout.com sites always use separate subscription
  return isCheckoutSite ? true : confVariables.SEPARATE_SUBSCRIPTION
}

/**
 * Get translation namespace
 * @returns {string}
 */
/* eslint-disable */
/*** Eslint disabled to avoid "Unexpected block statement surrounding arrow body." ***/
export const transNamespace = () => {
  return CONSTANTS.SITE !== null ? CONSTANTS.SITE : 'common'
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/services/conf-utils.js